import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/acp-mobile-sdkdocs/acp-mobile-sdkdocs/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
import Tabs from './tabs/api-reference.md';
import Alerts from '/src/pages/documentation/resources/alerts.md';
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const TabsBlock = makeShortcode("TabsBlock");
const InlineAlert = makeShortcode("InlineAlert");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "identity-api-reference"
    }}>{`Identity API reference`}</h1>
    <Alerts query="platform=outdated-version&componentClass=InlineNestedAlert" mdxType="Alerts" />
    <h2 {...{
      "id": "appendtourl--appendvisitorinfoforurl"
    }}>{`appendToURL / appendVisitorInfoForURL`}</h2>
    <p>{`This API appends Adobe visitor information to the query component of the specified URL.`}</p>
    <p>{`If the provided URL is null or empty, it is returned as is. Otherwise, the following information is added to the query component of the specified URL and is returned in the callback function:`}</p>
    <ul>
      <li parentName="ul">{`The `}<inlineCode parentName="li">{`adobe_mc`}</inlineCode>{` attribute is a URL encoded list that contains:`}
        <ul parentName="li">
          <li parentName="ul"><inlineCode parentName="li">{`MCMID`}</inlineCode>{` - Experience Cloud ID (ECID)`}</li>
          <li parentName="ul"><inlineCode parentName="li">{`MCORGID`}</inlineCode>{` - Experience Cloud Org ID`}</li>
          <li parentName="ul"><inlineCode parentName="li">{`MCAID`}</inlineCode>{` - Analytics Tracking ID (AID), if available from the `}<a parentName="li" {...{
              "href": "../../adobe-analytics/api-reference.md#gettrackingidentifier"
            }}>{`Analytics extension`}</a></li>
          <li parentName="ul"><inlineCode parentName="li">{`TS`}</inlineCode>{` - A timestamp taken when this request was made`}</li>
        </ul>
      </li>
      <li parentName="ul">{`The optional `}<inlineCode parentName="li">{`adobe_aa_vid`}</inlineCode>{` attribute is the URL-encoded Analytics Custom Visitor ID (VID), if previously set in the `}<a parentName="li" {...{
          "href": "../../adobe-analytics/api-reference.md#setvisitoridentifier"
        }}>{`Analytics extension`}</a>{`.`}</li>
    </ul>
    <p>{`This API is designed to handle the following URL formats:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-text"
      }}>{`scheme://authority/path?query=param#fragment
`}</code></pre>
    <p>{`In this example, the Adobe visitor data is appended as:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-text"
      }}>{`scheme://authority/path?query=param&adobe_mc=TS%3Dtimestamp%7CMCMID%3Decid%7CMCORGID%3Decorgid%40AdobeOrg#fragment
`}</code></pre>
    <p>{`Similarly, URLs without a query component:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-text"
      }}>{`scheme://authority/path#fragment
`}</code></pre>
    <p>{`The Adobe visitor data is appended as:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-text"
      }}>{`scheme://authority/path?adobe_mc=TS%3Dtimestamp%7CMCMID%3Decid%7CMCORGID%3Decorgid%40AdobeOrg#fragment
`}</code></pre>
    <p>{`In these examples the `}<inlineCode parentName="p">{`adobe_mc`}</inlineCode>{` parameters are separated by "|" (pipe) and are encoded.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-text"
      }}>{`adobe_mc = TS=XXXXXX|MCMID=XXXXXX|MCAID=XXXXXX|MCORGID=XXXXXX@AdobeOrg
`}</code></pre>
    <p>{`If your application uses more complicated URLs, such as Angular URLs, you should use `}<a parentName="p" {...{
        "href": "#geturlvariables"
      }}>{`getUrlVariables`}</a>{`.`}</p>
    <TabsBlock orientation="horizontal" slots="heading, content" repeat="7" mdxType="TabsBlock" />
    <p>{`Android`}</p>
    <Tabs query="platform=android&api=append-to-url" mdxType="Tabs" />
    <p>{`iOS`}</p>
    <Tabs query="platform=ios&api=append-to-url" mdxType="Tabs" />
    <p>{`React Native`}</p>
    <Tabs query="platform=react-native&api=append-to-url" mdxType="Tabs" />
    <p>{`Flutter`}</p>
    <Tabs query="platform=flutter&api=append-to-url" mdxType="Tabs" />
    <p>{`Cordova`}</p>
    <Tabs query="platform=cordova&api=append-to-url" mdxType="Tabs" />
    <p>{`Unity`}</p>
    <Tabs query="platform=unity&api=append-to-url" mdxType="Tabs" />
    <p>{`Xamarin`}</p>
    <Tabs query="platform=xamarin&api=append-to-url" mdxType="Tabs" />
    <h2 {...{
      "id": "extensionversion"
    }}>{`extensionVersion`}</h2>
    <p>{`The `}<inlineCode parentName="p">{`extensionVersion()`}</inlineCode>{` API returns the version of the Identity extension that is registered with the Mobile Core extension.`}</p>
    <p>{`To get the version of the Identity extension, use the following code sample:`}</p>
    <TabsBlock orientation="horizontal" slots="heading, content" repeat="7" mdxType="TabsBlock" />
    <p>{`Android`}</p>
    <Tabs query="platform=android&api=extension-version" mdxType="Tabs" />
    <p>{`iOS`}</p>
    <Tabs query="platform=ios&api=extension-version" mdxType="Tabs" />
    <p>{`React Native`}</p>
    <Tabs query="platform=react-native&api=extension-version" mdxType="Tabs" />
    <p>{`Flutter`}</p>
    <Tabs query="platform=flutter&api=extension-version" mdxType="Tabs" />
    <p>{`Cordova`}</p>
    <Tabs query="platform=cordova&api=extension-version" mdxType="Tabs" />
    <p>{`Unity`}</p>
    <Tabs query="platform=unity&api=extension-version" mdxType="Tabs" />
    <p>{`Xamarin`}</p>
    <Tabs query="platform=xamarin&api=extension-version" mdxType="Tabs" />
    <h2 {...{
      "id": "getexperiencecloudid"
    }}>{`getExperienceCloudId`}</h2>
    <p>{`This API retrieves the Adobe Experience Cloud ID (ECID) that was generated when the app was initially launched and is stored in the Adobe Experience Cloud Identity Service.`}</p>
    <p>{`This ID is preserved between app upgrades, is saved and restored during the standard application backup process, and is removed at uninstall.`}</p>
    <TabsBlock orientation="horizontal" slots="heading, content" repeat="7" mdxType="TabsBlock" />
    <p>{`Android`}</p>
    <Tabs query="platform=android&api=get-experience-cloud-id" mdxType="Tabs" />
    <p>{`iOS`}</p>
    <Tabs query="platform=ios&api=get-experience-cloud-id" mdxType="Tabs" />
    <p>{`React Native`}</p>
    <Tabs query="platform=react-native&api=get-experience-cloud-id" mdxType="Tabs" />
    <p>{`Flutter`}</p>
    <Tabs query="platform=flutter&api=get-experience-cloud-id" mdxType="Tabs" />
    <p>{`Cordova`}</p>
    <Tabs query="platform=cordova&api=get-experience-cloud-id" mdxType="Tabs" />
    <p>{`Unity`}</p>
    <Tabs query="platform=unity&api=get-experience-cloud-id" mdxType="Tabs" />
    <p>{`Xamarin`}</p>
    <Tabs query="platform=xamarin&api=get-experience-cloud-id" mdxType="Tabs" />
    <h2 {...{
      "id": "getidentifiers"
    }}>{`getIdentifiers`}</h2>
    <p>{`This API returns all customer identifiers that were previously synced with the Adobe Experience Cloud Identity Service.`}</p>
    <TabsBlock orientation="horizontal" slots="heading, content" repeat="7" mdxType="TabsBlock" />
    <p>{`Android`}</p>
    <Tabs query="platform=android&api=get-identifiers" mdxType="Tabs" />
    <p>{`iOS`}</p>
    <Tabs query="platform=ios&api=get-identifiers" mdxType="Tabs" />
    <p>{`React Native`}</p>
    <Tabs query="platform=react-native&api=get-identifiers" mdxType="Tabs" />
    <p>{`Flutter`}</p>
    <Tabs query="platform=flutter&api=get-identifiers" mdxType="Tabs" />
    <p>{`Cordova`}</p>
    <Tabs query="platform=cordova&api=get-identifiers" mdxType="Tabs" />
    <p>{`Unity`}</p>
    <Tabs query="platform=unity&api=get-identifiers" mdxType="Tabs" />
    <p>{`Xamarin`}</p>
    <Tabs query="platform=xamarin&api=get-identifiers" mdxType="Tabs" />
    <h2 {...{
      "id": "geturlvariables"
    }}>{`getUrlVariables`}</h2>
    <p>{`This API gets the Adobe Experience Cloud Identity Service variables in URL query parameter form, and these variables will be consumed by the hybrid app. This method returns an appropriately formed string that contains the Experience Cloud Identity Service URL variables. There will be no leading (&) or (?) punctuation because the caller is responsible for placing the variables in their resulting URL in the correct location.`}</p>
    <p>{`If an error occurs while retrieving the URL string, the callback handler will be called with a null value. Otherwise, the following information is added to the string that is returned in the callback:`}</p>
    <ul>
      <li parentName="ul">{`The `}<inlineCode parentName="li">{`adobe_mc`}</inlineCode>{` attribute is an URL encoded list that contains:`}
        <ul parentName="li">
          <li parentName="ul"><inlineCode parentName="li">{`MCMID`}</inlineCode>{` - Experience Cloud ID (ECID)`}</li>
          <li parentName="ul"><inlineCode parentName="li">{`MCORGID`}</inlineCode>{` - Experience Cloud Org ID`}</li>
          <li parentName="ul"><inlineCode parentName="li">{`MCAID`}</inlineCode>{` - Analytics Tracking ID (AID), if available from the `}<a parentName="li" {...{
              "href": "../../adobe-analytics/index.md"
            }}>{`Analytics extension`}</a></li>
          <li parentName="ul"><inlineCode parentName="li">{`TS`}</inlineCode>{` - A timestamp taken when this request was made`}</li>
        </ul>
      </li>
      <li parentName="ul">{`The optional `}<inlineCode parentName="li">{`adobe_aa_vid`}</inlineCode>{` attribute is the URL-encoded Analytics Custom Visitor ID (VID), if previously set in the `}<a parentName="li" {...{
          "href": "../../adobe-analytics/index.md"
        }}>{`Analytics extension`}</a>{`.`}</li>
    </ul>
    <TabsBlock orientation="horizontal" slots="heading, content" repeat="7" mdxType="TabsBlock" />
    <p>{`Android`}</p>
    <Tabs query="platform=android&api=get-url-variables" mdxType="Tabs" />
    <p>{`iOS`}</p>
    <Tabs query="platform=ios&api=get-url-variables" mdxType="Tabs" />
    <p>{`React Native`}</p>
    <Tabs query="platform=react-native&api=get-url-variables" mdxType="Tabs" />
    <p>{`Flutter`}</p>
    <Tabs query="platform=flutter&api=get-url-variables" mdxType="Tabs" />
    <p>{`Cordova`}</p>
    <Tabs query="platform=cordova&api=get-url-variables" mdxType="Tabs" />
    <p>{`Unity`}</p>
    <Tabs query="platform=unity&api=get-url-variables" mdxType="Tabs" />
    <p>{`Xamarin`}</p>
    <Tabs query="platform=xamarin&api=get-url-variables" mdxType="Tabs" />
    <h2 {...{
      "id": "registerextension"
    }}>{`registerExtension`}</h2>
    <p>{`The `}<inlineCode parentName="p">{`registerExtension()`}</inlineCode>{` API registers the Identity extension with the Mobile Core extension. This API allows the extension to send and receive events to and from the Mobile SDK.`}</p>
    <TabsBlock orientation="horizontal" slots="heading, content" repeat="7" mdxType="TabsBlock" />
    <p>{`Android`}</p>
    <Tabs query="platform=android&api=register-extension" mdxType="Tabs" />
    <p>{`iOS`}</p>
    <Tabs query="platform=ios&api=register-extension" mdxType="Tabs" />
    <p>{`React Native`}</p>
    <Tabs query="platform=react-native&api=register-extension" mdxType="Tabs" />
    <p>{`Flutter`}</p>
    <Tabs query="platform=flutter&api=register-extension" mdxType="Tabs" />
    <p>{`Cordova`}</p>
    <Tabs query="platform=cordova&api=register-extension" mdxType="Tabs" />
    <p>{`Unity`}</p>
    <Tabs query="platform=unity&api=register-extension" mdxType="Tabs" />
    <p>{`Xamarin`}</p>
    <Tabs query="platform=xamarin&api=register-extension" mdxType="Tabs" />
    <h2 {...{
      "id": "setadvertisingidentifier"
    }}>{`setAdvertisingIdentifier`}</h2>
    <p>{`The advertising ID is preserved between app upgrades, is saved and restored during the standard application backup process, available via the `}<a parentName="p" {...{
        "href": "../signal/index.md"
      }}>{`Signals`}</a>{` extension, and is removed at uninstall.`}</p>
    <InlineAlert variant="info" slots="text" mdxType="InlineAlert" />
    <p>{`If the current SDK privacy status is `}<inlineCode parentName="p">{`optedout`}</inlineCode>{`, the advertising identifier is not set or stored.`}</p>
    <TabsBlock orientation="horizontal" slots="heading, content" repeat="7" mdxType="TabsBlock" />
    <p>{`Android`}</p>
    <Tabs query="platform=android&api=set-advertising-identifier" mdxType="Tabs" />
    <p>{`iOS`}</p>
    <Tabs query="platform=ios&api=set-advertising-identifier" mdxType="Tabs" />
    <p>{`React Native`}</p>
    <Tabs query="platform=react-native&api=set-advertising-identifier" mdxType="Tabs" />
    <p>{`Flutter`}</p>
    <Tabs query="platform=flutter&api=set-advertising-identifier" mdxType="Tabs" />
    <p>{`Cordova`}</p>
    <Tabs query="platform=cordova&api=set-advertising-identifier" mdxType="Tabs" />
    <p>{`Unity`}</p>
    <Tabs query="platform=unity&api=set-advertising-identifier" mdxType="Tabs" />
    <p>{`Xamarin`}</p>
    <Tabs query="platform=xamarin&api=set-advertising-identifier" mdxType="Tabs" />
    <h2 {...{
      "id": "setpushidentifier"
    }}>{`setPushIdentifier`}</h2>
    <p>{`This API sets the device token for push notifications in the SDK. If the current SDK privacy status is `}<inlineCode parentName="p">{`optedout`}</inlineCode>{`, the push identifier is not set.`}</p>
    <InlineAlert variant="info" slots="text" mdxType="InlineAlert" />
    <p>{`You should call `}<inlineCode parentName="p">{`setPushIdentifier`}</inlineCode>{` on each application launch to ensure the most up-to-date device token is set to the SDK. If no device token is available, `}<inlineCode parentName="p">{`null`}</inlineCode>{`/`}<inlineCode parentName="p">{`nil`}</inlineCode>{` should be passed.`}</p>
    <TabsBlock orientation="horizontal" slots="heading, content" repeat="3" mdxType="TabsBlock" />
    <p>{`Android`}</p>
    <Tabs query="platform=android&api=set-push-identifier" mdxType="Tabs" />
    <p>{`iOS`}</p>
    <Tabs query="platform=ios&api=set-push-identifier" mdxType="Tabs" />
    <p>{`React Native`}</p>
    <Tabs query="platform=react-native&api=set-push-identifier" mdxType="Tabs" />
    <h2 {...{
      "id": "syncidentifier"
    }}>{`syncIdentifier`}</h2>
    <p>{`The `}<inlineCode parentName="p">{`syncIdentifier()`}</inlineCode>{` and `}<inlineCode parentName="p">{`syncIdentifiers()`}</inlineCode>{` APIs update the specified customer IDs with the Adobe Experience Cloud Identity Service.`}</p>
    <p>{`These APIs synchronize the provided customer identifier type key and value with the authentication state to the Experience Cloud Identity Service. If the specified customer ID type exists in the service, this ID type is updated with the new ID and the authentication state. Otherwise, a new customer ID is added.`}</p>
    <p>{`Starting with `}<em parentName="p">{`ACPIdentity v2.1.3 (iOS)`}</em>{` and `}<em parentName="p">{`Identity v1.1.2 (Android)`}</em>{` if the new `}<inlineCode parentName="p">{`identifier`}</inlineCode>{` value is null or empty, this ID type is removed from the local storage, Identity shared state and not synced with the Experience Cloud Identity Service.`}</p>
    <p>{`These IDs are preserved between app upgrades, are saved and restored during the standard application backup process, and are removed at uninstall.`}</p>
    <p>{`If the current SDK privacy status is `}<inlineCode parentName="p">{`MobilePrivacyStatus.OPT_OUT`}</inlineCode>{`, calling this method results in no operations being performed.`}</p>
    <p>{`This API updates or appends the provided customer identifier type key and value with the given authentication state to the Experience Cloud Identity Service. If the specified customer ID type exists in the service, the ID is updated with the new ID and authentication state. Otherwise a new customer ID is added.`}</p>
    <TabsBlock orientation="horizontal" slots="heading, content" repeat="7" mdxType="TabsBlock" />
    <p>{`Android`}</p>
    <Tabs query="platform=android&api=sync-identifier" mdxType="Tabs" />
    <p>{`iOS`}</p>
    <Tabs query="platform=ios&api=sync-identifier" mdxType="Tabs" />
    <p>{`React Native`}</p>
    <Tabs query="platform=react-native&api=sync-identifier" mdxType="Tabs" />
    <p>{`Flutter`}</p>
    <Tabs query="platform=flutter&api=sync-identifier" mdxType="Tabs" />
    <p>{`Cordova`}</p>
    <Tabs query="platform=cordova&api=sync-identifier" mdxType="Tabs" />
    <p>{`Unity`}</p>
    <Tabs query="platform=unity&api=sync-identifier" mdxType="Tabs" />
    <p>{`Xamarin`}</p>
    <Tabs query="platform=xamarin&api=sync-identifier" mdxType="Tabs" />
    <h2 {...{
      "id": "syncidentifiers"
    }}>{`syncIdentifiers`}</h2>
    <p>{`This API is an overloaded version, which does not include the parameter for the authentication state and it assumes a default value of `}<inlineCode parentName="p">{`VisitorID.AuthenticationState.UNKNOWN`}</inlineCode>{`.`}</p>
    <TabsBlock orientation="horizontal" slots="heading, content" repeat="7" mdxType="TabsBlock" />
    <p>{`Android`}</p>
    <Tabs query="platform=android&api=sync-identifiers" mdxType="Tabs" />
    <p>{`iOS`}</p>
    <Tabs query="platform=ios&api=sync-identifiers" mdxType="Tabs" />
    <p>{`React Native`}</p>
    <Tabs query="platform=react-native&api=sync-identifiers" mdxType="Tabs" />
    <p>{`Flutter`}</p>
    <Tabs query="platform=flutter&api=sync-identifiers" mdxType="Tabs" />
    <p>{`Cordova`}</p>
    <Tabs query="platform=cordova&api=sync-identifiers" mdxType="Tabs" />
    <p>{`Unity`}</p>
    <Tabs query="platform=unity&api=sync-identifiers" mdxType="Tabs" />
    <p>{`Xamarin`}</p>
    <Tabs query="platform=xamarin&api=sync-identifiers" mdxType="Tabs" />
    <h2 {...{
      "id": "syncidentifiers-overloaded"
    }}>{`syncIdentifiers (overloaded)`}</h2>
    <p>{`The function of this API is the same as the `}<inlineCode parentName="p">{`syncIdentifier`}</inlineCode>{` API. This API passes a list of identifiers, and each identifier contains an `}<inlineCode parentName="p">{`identifier type`}</inlineCode>{` as the key and an `}<inlineCode parentName="p">{`identifier`}</inlineCode>{` as the value. In each identifier pair, if the `}<inlineCode parentName="p">{`identifier type`}</inlineCode>{` contains a null or an empty string, the identifier is ignored by the Identity extension.`}</p>
    <p>{`Starting with `}<em parentName="p">{`ACPIdentity v2.1.3 (iOS)`}</em>{` and `}<em parentName="p">{`Identity v1.1.2 (Android)`}</em>{` if the new `}<inlineCode parentName="p">{`identifier`}</inlineCode>{` value is null or empty, this ID type is removed from the local storage, Identity shared state and not synced with the Adobe Experience Cloud Identity Service.`}</p>
    <TabsBlock orientation="horizontal" slots="heading, content" repeat="7" mdxType="TabsBlock" />
    <p>{`Android`}</p>
    <Tabs query="platform=android&api=sync-identifiers-overloaded" mdxType="Tabs" />
    <p>{`iOS`}</p>
    <Tabs query="platform=ios&api=sync-identifiers-overloaded" mdxType="Tabs" />
    <p>{`React Native`}</p>
    <Tabs query="platform=react-native&api=sync-identifiers-overloaded" mdxType="Tabs" />
    <p>{`Flutter`}</p>
    <Tabs query="platform=flutter&api=sync-identifiers-overloaded" mdxType="Tabs" />
    <p>{`Cordova`}</p>
    <Tabs query="platform=cordova&api=sync-identifiers-overloaded" mdxType="Tabs" />
    <p>{`Unity`}</p>
    <Tabs query="platform=unity&api=sync-identifiers-overloaded" mdxType="Tabs" />
    <p>{`Xamarin`}</p>
    <Tabs query="platform=xamarin&api=sync-identifiers-overloaded" mdxType="Tabs" />
    <h2 {...{
      "id": "public-classes"
    }}>{`Public classes`}</h2>
    <TabsBlock orientation="horizontal" slots="heading, content" repeat="7" mdxType="TabsBlock" />
    <p>{`Android`}</p>
    <Tabs query="platform=android&api=public-classes" mdxType="Tabs" />
    <p>{`iOS`}</p>
    <Tabs query="platform=ios&api=public-classes" mdxType="Tabs" />
    <p>{`React Native`}</p>
    <Tabs query="platform=react-native&api=public-classes" mdxType="Tabs" />
    <p>{`Flutter`}</p>
    <Tabs query="platform=flutter&api=public-classes" mdxType="Tabs" />
    <p>{`Cordova`}</p>
    <Tabs query="platform=cordova&api=public-classes" mdxType="Tabs" />
    <p>{`Unity`}</p>
    <Tabs query="platform=unity&api=public-classes" mdxType="Tabs" />
    <p>{`Xamarin`}</p>
    <Tabs query="platform=xamarin&api=public-classes" mdxType="Tabs" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      